import { useState } from "react";

export const usePaginationReset = () => {
  const [paginationResetCount, setPaginationResetCount] = useState(0);

  return {
    paginationResetCount,
    setPaginationResetCount,
  };
};
